import { DomainModel, secureRandomString } from 'domains/models';
import { AnswerType } from './answerType';

export const otherSelectValue = 'other';

interface Props {
  routineId: number | null;
  routineBatchId: number | null;
  userId: string | null;
  uid: string;
  question: string; // 元の質問が消えても、質問内容が残るように
  answerType: AnswerType;
  contentId: string | null;
  content: string | null;
  formId: number | null;
  formAnswerId: number | null;
  answerableType: string | null;
  answerableId: number | null;
}

export default class Answer extends DomainModel {
  routineId: number | null;
  routineBatchId: number | null;
  userId: string | null;
  uid: string;
  question: string;
  answerType: AnswerType;
  contentId: string | null;
  content: string | null;
  formId: number | null;
  formAnswerId: number | null;
  answerableType: string | null;
  answerableId: number | null;

  constructor(props: Props) {
    super(props);
    this._className = 'Answer';
    this.routineId = props.routineId;
    this.routineBatchId = props.routineBatchId;
    this.question = props.question;
    this.userId = props.userId;
    this.uid = props.uid;
    this.answerType = props.answerType;
    this.contentId = props.contentId;
    this.content = props.content;
    this.formId = props.formId;
    this.formAnswerId = props.formAnswerId;
    this.answerableType = props.answerableType;
    this.answerableId = props.answerableId;
  }

  static createEventAnswer(
    formId: number,
    userId: string | null,
    answerType: AnswerType,
    question: string,
    content: string,
    answerableId: number,
  ) {
    const newAnswer = new Answer({
      formId,
      userId,
      uid: secureRandomString(),
      answerType,
      routineId: null,
      routineBatchId: null,
      question,
      content,
      contentId: null,
      answerableType: 'Event',
      answerableId,
      formAnswerId: null,
    });
    return newAnswer;
  }

  static permited = ['content', 'contentId'];

  static permit(updater: any) {
    return super.permit(updater, this.permited);
  }

  isValid() {
    super.beforeValidate();
    let p = '';

    p = 'routineId';
    // if (!this.routineId) {
    //   this.addError(p, 'E001');
    // }

    p = 'question';
    if (!this.question) {
      this.addError(p, 'E001');
    }

    p = 'userId';

    p = 'uid';
    if (!this.uid) {
      this.addError(p, 'E001');
    }

    p = 'answerType';
    if (!this.answerType) {
      this.addError(p, 'E001');
    }
    p = 'content';
    // if (!this.content) {
    //   this.addError(p, 'E001');
    // } else
    if (this.content && this.content.length > 2000) {
      this.addError('customQuestion', 'E003');
    }
    return super.isValid();
  }
}
